// Benennung der skalierten Dateien.
// Standard ist der Raumname (z. B. "Kueche.jpg", "Bad_02.jpg"). Solange kein Name
// gesetzt ist (manuell oder später per KI), bleibt der Originalname exakt erhalten.

// Vorschläge für das Namensfeld (mit Umlauten, werden beim Export dateisicher gemacht).
// "Zimmer" ist der Sammelbegriff für unmöblierte, nicht eindeutig zuordenbare Räume.
export const ROOM_SUGGESTIONS = [
  "Küche",
  "Wohnzimmer",
  "Esszimmer",
  "Wohn-Essbereich",
  "Schlafzimmer",
  "Kinderzimmer",
  "Arbeitszimmer",
  "Gästezimmer",
  "Zimmer",
  "Bad",
  "Gäste-WC",
  "Flur",
  "Diele",
  "Treppenhaus",
  "Abstellraum",
  "Hauswirtschaftsraum",
  "Keller",
  "Dachboden",
  "Balkon",
  "Terrasse",
  "Loggia",
  "Garten",
  "Garage",
  "Stellplatz",
  "Außenansicht",
  "Straßenansicht",
  "Ausblick",
  "Grundriss",
];

// Namen der Titelbild-Exporte – dürfen von Raumnamen nicht überschrieben werden.
export const RESERVED_NAMES = [
  "Titelbild_4-3",
  "Titelbild_3-4",
  "Titelbild_Alternativ_4-3",
  "Titelbild_Alternativ_3-4",
];

export function originalBase(fileName: string): string {
  const dot = fileName.lastIndexOf(".");
  return dot > 0 ? fileName.slice(0, dot) : fileName;
}

// Eingegebenen Namen dateisicher machen: Umlaute umschreiben, Leerzeichen und "/" zu "-",
// alles außer Buchstaben, Ziffern, "-", "_" und "." entfernen.
export function toFileBase(text: string): string {
  return text
    .trim()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/Ä/g, "Ae")
    .replace(/Ö/g, "Oe")
    .replace(/Ü/g, "Ue")
    .replace(/ß/g, "ss")
    .replace(/[\s/\\]+/g, "-")
    .replace(/[^A-Za-z0-9._-]/g, "")
    .replace(/-{2,}/g, "-")
    .replace(/^[-.]+|[-.]+$/g, "")
    .replace(/\.jpe?g$/i, "");
}

// Endgültige Dateinamen (ohne Endung) für alle Bilder, in Reihenfolge der Galerie.
// Kommt ein Name mehrfach vor, wird durchnummeriert: Bad_01, Bad_02 …
export function resolveOutputNames(
  fileNames: string[],
  names: Record<string, string>,
): Record<string, string> {
  const bases = fileNames.map((f) => {
    const typed = names[f]?.trim();
    let safe = typed ? toFileBase(typed) : "";
    // Eingegebene Raumnamen vorne groß ("küche" -> "Kueche"); Originalnamen bleiben exakt.
    if (safe) safe = safe.charAt(0).toUpperCase() + safe.slice(1);
    return { file: f, base: safe || originalBase(f) };
  });

  // Gleiche Namen (ohne Rücksicht auf Groß/Klein) bilden eine Gruppe mit einheitlicher
  // Schreibweise: die des ersten Bildes der Gruppe.
  const count = new Map<string, number>();
  const canonical = new Map<string, string>();
  for (const b of bases) {
    const key = b.base.toLowerCase();
    count.set(key, (count.get(key) ?? 0) + 1);
    if (!canonical.has(key)) canonical.set(key, b.base);
  }

  const used = new Set(RESERVED_NAMES.map((n) => n.toLowerCase()));
  const nextIndex = new Map<string, number>();
  const result: Record<string, string> = {};

  for (const { file, base } of bases) {
    const key = base.toLowerCase();
    const group = canonical.get(key) ?? base;
    let name = group;
    if ((count.get(key) ?? 0) > 1 || used.has(key)) {
      let n = nextIndex.get(key) ?? 1;
      do {
        name = `${group}_${String(n).padStart(2, "0")}`;
        n++;
      } while (used.has(name.toLowerCase()));
      nextIndex.set(key, n);
    }
    used.add(name.toLowerCase());
    result[file] = name;
  }
  return result;
}
